var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"circle pulse",style:({ width: `${_setup.size}px`, height: `${_setup.size}px`, background: _setup.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }